import React, { memo } from 'react'
import {
  faPlus,
  faMinus,
  faClock,
  faCheckCircle,
  faTimesCircle,
  faArrowRotateLeft,
  faHourglass,
  faArrowUpRight,
  faArrowDownLeft
} from '@fortawesome/pro-duotone-svg-icons'
import {
  Avatar,
  Badge,
  badgeClasses,
  Box,
  ListItemText,
  TableCell,
  TableRow
} from '@mui/material'

import {
  TRANSACTION_TYPE,
  TRANSACTION_STATUS,
  TRANSACTION_STATUS_LABEL
} from '../../constants/transactions'

import { Label } from '../shared/label'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const TransactionRow = ({
  t,
  heading,
  type,
  label,
  title,
  date,
  status,
  onClick,
  anchor,
  theme
}) => {
  const { icon: statusIcon, color: statusColor } = getStatusIcon(status)

  const lightMode = theme.palette.mode === 'light'

  const { typeIcon, txnIcon, color } = getTypeIcon(type)

  const renderAvatar = () => (
    <Box sx={{ position: 'relative' }}>
      <Badge
        overlap='circular'
        color={color}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
          <FaIcon
            icon={txnIcon}
            width={18}
            style={{ '--fa-secondary-opacity': '1' }}
          />
        }
        sx={{ [`& .${badgeClasses.badge}`]: { p: 0, width: 20 } }}
      >
        <Avatar
          sx={{
            width: 48,
            height: 48,
            color: `${color}.main`,
            bgcolor: 'background.neutral'
          }}
        >
          <FaIcon icon={typeIcon} size='lg' />
        </Avatar>
      </Badge>
    </Box>
  )

  return (
    <TableRow onClick={onClick} sx={{ cursor: anchor && 'pointer' }}>
      <TableCell>
        <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
          {renderAvatar()}
          <ListItemText primary={heading} secondary={title} />
        </Box>
      </TableCell>
      <TableCell>{label}</TableCell>
      <TableCell>
        <ListItemText
          primary={date}
          // secondary={}
          slotProps={{
            primary: { sx: { typography: 'body2' } },
            secondary: {
              sx: { mt: 0.5, typography: 'caption' }
            }
          }}
        />
      </TableCell>
      <TableCell>
        <Label
          variant={lightMode ? 'soft' : 'filled'}
          startIcon={statusIcon}
          color={statusColor}
          sx={{ textTransform: 'capitalize' }}
        >
          {t(`transaction-history.status-label.${status}`)}
        </Label>
      </TableCell>
    </TableRow>
  )
}

export default memo(TransactionRow)

const getTypeIcon = (type) => {
  switch (type) {
    case TRANSACTION_TYPE.REDEEM:
      return {
        typeIcon: faMinus,
        txnIcon: faArrowUpRight,
        color: 'error'
      }
    default:
      return {
        typeIcon: faPlus,
        txnIcon: faArrowDownLeft,
        color: 'success'
      }
  }
}

const getStatusIcon = (status) => {
  switch (status) {
    case TRANSACTION_STATUS.PENDING:
      return {
        icon: faClock,
        color: 'warning'
      }
    case TRANSACTION_STATUS.SUCCESS:
      return {
        icon: faCheckCircle,
        color: 'success'
      }
    case TRANSACTION_STATUS.FAILED:
      return {
        icon: faTimesCircle,
        color: 'error'
      }
    case TRANSACTION_STATUS.CANCELLED:
      return {
        icon: faArrowRotateLeft,
        color: 'warning'
      }
    case TRANSACTION_STATUS_LABEL.FUTURE:
      return {
        icon: faHourglass,
        color: 'warning'
      }
    default:
      return ''
  }
}
